import { SourceBasedExpression } from './Expression.js';
export class NativeJsFunctionCallExpression extends SourceBasedExpression {
    constructor(source, fn, params) {
        super(source);
        this.fn = fn;
        this.params = (params || []).filter(param => !!param);
    }
    getFn() {
        return this.fn;
    }
    getParams() {
        return this.params;
    }
    evaluate(visitor, localVariables) {
        const source = this.getSource()
            .evaluate(visitor, localVariables);
        const params = this.getParams()
            .map(param => param.evaluate(visitor, localVariables));
        if (!source) {
            return false;
        }
        const fn = source[this.getFn()];
        const isFunction = typeof fn === 'function';
        if (isFunction) {
            return fn.apply(source, params);
        }
        else {
            throw new Error(`No function ${this.fn} in ${JSON.stringify(source)}`);
        }
    }
}
//# sourceMappingURL=NativeJsFunctionCallExpression.js.map